<ng-container *ngIf="!(srvRpDesign.isMobile$ | async)">
  <div class="bg-white">
    <div class="px-0 px-sm-3 m-3 d-flex justify-content-center">
      <div [ngStyle]="UIUtilityService.getHeaderStyle()">
        <span mat-dialog-title class="font-dialog-confirm-title">{{ data.title }}</span>
      </div>
    </div>

    <ng-container *ngIf="data.dialogType != DialogType.IMAGE" [ngTemplateOutlet]="TEXT"></ng-container>

    <ng-container *ngIf="data.dialogType == DialogType.IMAGE" [ngTemplateOutlet]="IMAGE"></ng-container>


    <div class="my-3 d-flex justify-content-center gap-3" mat-dialog-actions>
      @if (data.otherButtonText) {
        <button class="btn-lg py-4 px-4 px-sm-5 font-button" mat-button [mat-dialog-close]="" [disabled]="this.srvConfirm.isProcessing" (click)="other($event)" [ngClass]="otherButtonStyle">
          {{ data.otherButtonText }}
        </button>
      }
      @if (data.cancelButtonText) {
        <button class="btn-lg py-4 px-4 px-sm-5 font-button" mat-button [mat-dialog-close]="" [disabled]="this.srvConfirm.isProcessing" (click)="cancel($event)" [ngClass]="cancelButtonStyle">
          {{ data.cancelButtonText }}
        </button>
      }
      @if (data.confirmButtonText) {
        <button class="btn-lg py-4 px-4 px-sm-5 font-button" mat-button [mat-dialog-close]="" [disabled]="this.srvConfirm.isProcessing" (click)="confirm($event)" cdkFocusInitial [ngClass]="confirmButtonStyle">
          {{ data.confirmButtonText }}
        </button>
      }
    </div>
  </div>
</ng-container>

<ng-container *ngIf="(srvRpDesign.isMobile$ | async)">
  <div class="bg-white p-4">
    <div class="d-flex justify-content-center" [ngStyle]="UIUtilityService.getHeaderStyle()">
      <span class="mobile-font-dialog-confirm-title text-center">{{ data.title }}</span>
    </div>

    <ng-container *ngIf="data.dialogType != DialogType.IMAGE" [ngTemplateOutlet]="TEXT"></ng-container>

    <ng-container *ngIf="data.dialogType == DialogType.IMAGE" [ngTemplateOutlet]="IMAGE"></ng-container>

    <div class="d-flex justify-content-center gap-2">
      @if (data.otherButtonText) {
        <button class="p-4 font-button" mat-button [mat-dialog-close]="" [disabled]="this.srvConfirm.isProcessing" (click)="other($event)" [ngClass]="otherButtonStyle">
          {{ data.otherButtonText }}
        </button>
      }
      @if (data.cancelButtonText) {
        <button class="p-4 font-button" mat-button [mat-dialog-close]="" [disabled]="this.srvConfirm.isProcessing" (click)="cancel($event)" [ngClass]="cancelButtonStyle">
          {{ data.cancelButtonText }}
        </button>
      }
      @if (data.confirmButtonText) {
        <button class="p-4 font-button" mat-button [mat-dialog-close]="" [disabled]="this.srvConfirm.isProcessing" (click)="confirm($event)" cdkFocusInitial [ngClass]="confirmButtonStyle">
          {{ data.confirmButtonText }}
        </button>
      }
    </div>
  </div>
</ng-container>


<ng-template #TEXT>
  <div class="item-center" [ngClass]="iconStyle" *ngIf="data.dialogType == DialogType.DELETE">
    <div>
      <mat-icon svgIcon="falTimesCircle" class="icon-center" [ngStyle]="UIUtilityService.getDangerIconStyle()"></mat-icon>
    </div>
  </div>
  <div class="item-center" [ngClass]="iconStyle" *ngIf="data.dialogType == DialogType.REJECT">
    <div>
      <mat-icon svgIcon="falTimesCircle" class="icon-center" [ngStyle]="UIUtilityService.getDangerIconStyle()"></mat-icon>
    </div>
  </div>
  <div class="item-center" [ngClass]="iconStyle" *ngIf="data.dialogType == DialogType.CANCEL">
    <div>
      <mat-icon svgIcon="falBan" class="icon-center" [ngStyle]="UIUtilityService.getWarningIconStyle()"></mat-icon>
    </div>
  </div>
  <div class="item-center" [ngClass]="iconStyle" *ngIf="data.dialogType == DialogType.CONFIRM">
    <div>
      <mat-icon svgIcon="falCheckCircle" class="icon-center" [ngStyle]="UIUtilityService.getWarningIconStyle()"></mat-icon>
    </div>
  </div>
  <div class="item-center" [ngClass]="iconStyle" *ngIf="data.dialogType == DialogType.INFO">
    <div>
      <mat-icon svgIcon="falInfoCircle" class="icon-center" [ngStyle]="UIUtilityService.getWarningIconStyle()"></mat-icon>
    </div>
  </div>

  <ng-container *ngIf="!(srvRpDesign.isMobile$ | async)">
    <div class="mt-4 mx-3 font-dialog-confirm-content" mat-dialog-content>
      <p [class]="messageStyle" *ngFor="let msg of message">{{ msg }}</p>
    </div>

    <div class="ms-5 mt-0 pt-0 font-dialog-confirm-content text-left" mat-dialog-content *ngIf="bulletMessage.length !=0 ">
      <ul [class]="bulletStyle">
        <li *ngFor="let msg of bulletMessage">{{ msg }}</li>
      </ul>
    </div>
  </ng-container>

  <ng-container *ngIf="(srvRpDesign.isMobile$ | async)">
    <div class="my-3 p-0 mobile-font-dialog-confirm-content" mat-dialog-content>
      <p [class]="messageStyle" *ngFor="let msg of message">{{ msg }}</p>
    </div>
    <div class="ms-1 my-3 p-0 pt-0 mobile-font-dialog-confirm-content" mat-dialog-content *ngIf="bulletMessage.length !=0">
      <ul [class]="bulletStyle">
        <li *ngFor="let msg of bulletMessage">{{ msg }}</li>
      </ul>
    </div>
  </ng-container>
</ng-template>

<ng-template #IMAGE>
  <img class="image" [src]="message[0]">
</ng-template>